import React from "react";
import "./home.css";
import Header from "../../Components/Herder/Header";
import ComparisonTable from "../../Components/ComparisonTable/ComparisonTable";
import WhyChoseUs from "../../Components/WhyChoseUs/WhyChoseUs";
import FAQs from "../../Components/FAQs/FAQs";
import Footer from "../../Components/Footer/Footer";

const Home = () => {
  return (
    <>
      <Header />
      <ComparisonTable />
      <WhyChoseUs />
      <FAQs />
      <Footer />
    </>
  );
};

export default Home;
